import { ICPDState } from '../../types/cpd';

const defaultState: ICPDState = {
  availableRegionIds: [],
  isAvailableForCurrentRegion: false,
  landingUrl: undefined,
};

export function cpdReducer(state: ICPDState = defaultState): ICPDState {
  return state;
}
